import ErrorOverlay from './ErrorOverlay';

export default ErrorOverlay;
